import React from 'react';
import { Loader } from 'pixi.js'
import { AnimatedSprite, Container, useTick, Sprite } from '@inlet/react-pixi'

let thunderTextures = [];

const ThunderCloud = ({ _xPos, _yPos, speed, max, min, _xSize, _ySize }) => {

    const [xPos, setXPos] = React.useState(_xPos);
    const [isLTR, setIsLTR] = React.useState(true);
    const loader = Loader.shared;

    for (let i = 1; i <= 13; i++) {
        thunderTextures.push(loader.resources["./assets/images/components/island/spritesheets/skyAssets/lightning.json"].textures[i < 10 ? `lightning_animated000${i}.png` : `lightning_animated00${i}.png`]);
    }
    const cloudTexture = loader.resources["./assets/images/components/island/spritesheets/skyAssets/cloud.json"].textures[`cloud_thundercloud.png`];

    useTick(() => {
        if (isLTR) {
            setXPos(xPos + speed)
        }
        else if (!isLTR) {
            setXPos(xPos - speed)
        }

        if (xPos >= max)
            setIsLTR(false);
        else if (xPos <= min)
            setIsLTR(true);
    });

    return (
        <Container x={xPos} y={_yPos}>
            <AnimatedSprite
                y={40}
                animationSpeed={0.1}
                isPlaying={true} scale={{ x: _xSize, y: _ySize }}
                textures={thunderTextures}
            />
            <Sprite
                scale={{ x: 0.2, y: 0.2 }}
                texture={cloudTexture}
            />
        </Container>
    );
};

export { ThunderCloud as default }